import {
  Carrot,
  Salad,
  Apple,
  Fish,
  Beef,
  Egg,
  Milk,
  Croissant,
  Wheat,
  Package,
  Droplets,
  Snowflake,
  Cookie,
  CupSoda,
  Boxes,
  Leaf,
} from "lucide-react";

// カテゴリ名（キーワード）→ アイコン＋カラー
const RULES = [
  { kw: ["カット野菜", "サラダ"], Icon: Salad, color: "text-green-600" },
  { kw: ["野菜"], Icon: Carrot, color: "text-green-600" },
  { kw: ["果物", "フルーツ"], Icon: Apple, color: "text-red-500" },
  { kw: ["魚", "鮮魚", "水産"], Icon: Fish, color: "text-sky-600" },
  { kw: ["肉", "精肉"], Icon: Beef, color: "text-rose-600" },
  { kw: ["卵", "たまご"], Icon: Egg, color: "text-amber-500" },
  { kw: ["乳", "牛乳", "チーズ"], Icon: Milk, color: "text-sky-500" },
  { kw: ["パン"], Icon: Croissant, color: "text-amber-600" },
  { kw: ["米", "麺", "穀"], Icon: Wheat, color: "text-amber-600" },
  { kw: ["加工"], Icon: Package, color: "text-orange-500" },
  { kw: ["調味"], Icon: Droplets, color: "text-amber-700" },
  { kw: ["冷凍"], Icon: Snowflake, color: "text-sky-500" },
  { kw: ["菓子", "スイーツ", "デザート"], Icon: Cookie, color: "text-pink-500" },
  { kw: ["飲", "ドリンク", "茶"], Icon: CupSoda, color: "text-cyan-600" },
  { kw: ["資材", "消耗", "備品"], Icon: Boxes, color: "text-slate-500" },
];

export const categoryIcon = (name = "") => {
  for (const r of RULES) {
    if (r.kw.some((k) => name.includes(k))) return { Icon: r.Icon, color: r.color };
  }
  return { Icon: Leaf, color: "text-emerald-600" };
};
